import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Layout from "@/components/layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Solutions from "@/pages/Solutions";
import WhoWeServe from "@/pages/WhoWeServe";
import Security from "@/pages/Security";
import Developers from "@/pages/Developers";
import Partnerships from "@/pages/Partnerships";
import Contact from "@/pages/Contact";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/who-we-serve" element={<WhoWeServe />} />
            <Route path="/security" element={<Security />} />
            <Route path="/developers" element={<Developers />} />
            <Route path="/partnerships" element={<Partnerships />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Layout>
      </BrowserRouter>

      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;